import { useEffect, useState } from "react";
import { CalendarHeart } from "lucide-react";
import { api } from "../lib/api";
import { fmtDate, todayISO } from "../lib/format";
import { Panel } from "./Common";

export const UpcomingHolidays = ({ isAdmin }) => {
  const [list, setList] = useState([]);
  const [ents, setEnts] = useState({});
  useEffect(() => {
    const t = todayISO();
    const y = +t.slice(0, 4);
    Promise.all([y, y + 1].map((yr) => api.get("/holidays", { params: { year: String(yr) } })))
      .then((rs) => setList(rs.flatMap((r) => r.data).filter((h) => h.date >= t).slice(0, 6)));
    if (isAdmin) api.get("/entities").then((r) => setEnts(Object.fromEntries(r.data.map((e) => [e.id, e.name]))));
  }, [isAdmin]);
  const multi = Object.keys(ents).length > 1;
  return (
    <Panel title="Upcoming holidays" testid="upcoming-holidays">
      {!list.length ? <div className="text-sm text-[#6E6E73]" data-testid="upcoming-holidays-empty">No upcoming holidays</div> : (
        <div className="space-y-3">
          {list.map((h) => (
            <div key={h.id} className="flex items-center gap-3" data-testid={`upcoming-holiday-${h.date}`}>
              <CalendarHeart className="h-4 w-4 text-[#E08A1E] shrink-0" />
              <div className="min-w-0">
                <div className="text-sm font-semibold truncate">{h.name}</div>
                <div className="text-xs text-[#6E6E73]">{fmtDate(h.date)}{multi && ` · ${ents[h.entity_id] || ""}`}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
};
